import { Injectable } from '@angular/core';
import { AppSettings } from '../enums/app-settings.enum';
import { UtilitiesService } from '../utilities/utilities.service';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root',
})
export class AdobeAnalyticsService {
  private currency = AppSettings.LOCAL_CURRENTCY;
  private previousPageName: string = '';
  constructor(
    private UTS: UtilitiesService,
    private urlService: UrlService,
  ) {
    this.urlService.previousUrl$.subscribe((previousUrl: string) => {
      this.previousPageName = previousUrl;
    })
  }

  getItemCatType(item: any, addonType) {
    let type;
    if (item?.productType == 'MOBILE_CONTROLLINE' ||
      addonType && addonType.toLowerCase() == 'control' ||
      addonType && addonType.toLowerCase() == 'control line') { type = 'Control_line_plan'; }
    else if (item?.productType == 'MOBILE_VISITOR_PREPAID' || addonType && addonType.toLowerCase() == 'visitor line') { type = 'Visitor_line_plan'; }
    else if (item?.productType == 'MOBILE_POSTPAID') { type = 'Postpaid_plan'; }
    else if (item?.productType == 'MOBILE_PREPAID' || addonType && addonType.toLowerCase() == 'prepaid') { type = 'Prepaid_plan'; }
    else if (item?.commerceItemType == 'etsElifeSku') { type = 'eLife_plan'; }
    else { type = item?.commerceItemCategory; }
    localStorage.setItem('catName', type);
    return type
  }

  getProductType(item: any) {
    let _type;
    if (item?.productType == 'MOBILE_CONTROLLINE')
      return _type = 'plan';
    else if (item?.productType == 'MOBILE_POSTPAID' || item?.commerceItemType == 'etsElifeSku')
      return _type = 'plan';
    else if (item?.productType == 'MOBILE_PREPAID')
      return _type = 'plan';
    else
      return _type = 'device';
  }

  getPlanType(item: any) {
    let _type;
    if (item?.productType == 'MOBILE_CONTROLLINE')
      return _type = 'New control line' + ' ' + item?.displayName;
    else if (item?.productType == 'MOBILE_POSTPAID' || item?.commerceItemType == 'etsElifeSku')
      return _type = item.displayName;
    else if (item?.productType == 'MOBILE_PREPAID')
      return _type = item.displayName + 'Prepaid Line';
    else
      return _type = item?.displayName;
  }

  addFilterApplyEvent(category: string, type: string, value: string) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          "event": "filter",
          "filterDetails": {
            "filterCategory": category,
            "filterType": type,
            "filterValue": value,
          },
          "eventInfo": {
            "filterClick": 1
          }
        })
      }

    } catch (e) {
      this.UTS.error(e)
      console.error(e);
    }
  }

  addLinkCTAEvent(name: string, type: string, region: string, sectionHeading: string, action: string, linkName: any = null) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          "event": "linkClicked",
          "xdmActionDetails": {
            "web": {
              "webInteraction": {
                "name": name,
                "URL": window.location.href,
                "type": type,
                "region": region,
                "linkClicks": {
                  "value": 1
                }
              }
            },
            "linkInfo": {
              "sectionHeading": sectionHeading,
              "action": action,
              "name": linkName == null ? name : linkName
            }
          }
        })
      }
    } catch (e) {
      this.UTS.error(e)
      console.error(e);
    }
  }

  addSubscribeNowCTAEvent(name: string, type: string, region: string, sectionHeading: string, action: string, productName: string, price: string, productType: string,
    productCategory: string, productDescription: string) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          "event": "linkClicked",
          "xdmActionDetails": {
            "web": {
              "webInteraction": {
                "name": name,
                "URL": window.location.href,
                "type": type,
                "region": region,
                "linkClicks": {
                  "value": 1
                }
              }
            },
            "linkInfo": {
              "sectionHeading": sectionHeading,
              "action": action,
              "name": name
            },
            "product": {
              "productDetails": {
                "productName": productName || '',
                "productPrice": parseFloat(price) || 0,
                "productType": productType || '',
                "productCategory": productCategory || '',
                "productDescription": (productDescription && productDescription.toString().length > 0) ? productDescription.replace(/<[^>]*>/g, '') : ''
              }
            }
          }
        });
      }
    } catch (e) {
      this.UTS.error(e)
      console.error(e);
    }
  }

  pageLoadedEvent(pageName: string, section: string, error: boolean, eventInfo = null) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          "event": "pageLoaded",
          "xdmPageLoad": {
            "web": {
              "webPageDetails": {
                "name": (localStorage.getItem('language') ? localStorage.getItem('language') : 'en') + "-ae:" + section,		//Ex:en-ae:home
                "server": window.location.host,
                "siteSection": section,
                "siteSection1": "Home Navigation",
                "siteSection2": "",
                "siteSection3": "",
                "isErrorPage": error,
                "URL": window.location.href,
                "pageViews": {
                  "value": 1
                }
              }
            },
            "pageInfo": {
              "country": "ae",
              "language": localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
              "previousPageName": this.previousPageName ? this.previousPageName : '',
              "pageType": section,
              "pageLoadTime": Math.floor(performance.now() / 1000)
            },
            "user": {
              "loginStatus": sessionStorage.getItem("isLoggedIn") ? "logged-in" : "logged-out",
              "customerId": sessionStorage.getItem("userId"),
              "customerType": sessionStorage.getItem("permission")
            },
            "timestamp": Date.now(),
            "userAgentString": navigator.userAgent
          }, eventInfo: eventInfo
        });
      }
    } catch (e) {
      this.UTS.error(e)
      console.error(e);
    }
  };

  addCheckNumberAvailabilityCTAEvent(name: string, region: string, sectionHeading: string, action: string, digits: number, stdCode: string) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          "event": "linkClicked",
          "xdmActionDetails": {
            "web": {
              "webInteraction": {
                "name": name,
                "URL": window.location.href,
                "type": "other",
                "region": region,
                "linkClicks": {
                  "value": 1
                }
              }
            },
            "linkInfo": {
              "sectionHeading": sectionHeading,
              "action": action,
              "name": name
            },
            "user": {
              "favioriteNumberDigits": digits,
              "stdCode": stdCode
            }

          }
        });

      }
    } catch (e) {
      this.UTS.error(e)
      console.error(e);
    }
  }


  addToCartEvent(name: string, region: string, sectionHeading: string, action: string, sku: any) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          "event": "linkClicked",
          "xdmActionDetails": {
            "web": {
              "webInteraction": {
                "name": name,
                "URL": window.location.href,
                "type": "other",
                "region": region,
                "linkClicks": {
                  "value": 1
                }
              }
            },
            "linkInfo": {
              "sectionHeading": sectionHeading,
              "action": action,
              "name": name
            },
            "product": {
              "productDetails": {
                "productName": this.getPlanType(sku) || '',
                "productPrice": parseFloat(sku?.listPrice) || 0,
                "productType": this.getProductType(sku) || '',
                "productCategory": this.getItemCatType(sku, null) || '',
                "productDescription": sku.displayName || '',
              }
            },
            "eventInfo": {
              "cartAdd": 1
            }
          }
        });
      }
    } catch (e) {
      this.UTS.error(e)
    }

  }

  pageErrorEvent(pageName: string, section: string, errorMessage: string, errorCode: string, apiError: boolean) {
    try {
      if (window.adobeDataLayer) {
        //Setting only Page Level variables on page loading complete
        window.adobeDataLayer.push({
          "event": "errorInteraction",
          "xdmPageLoad": {
            "web": {
              "webPageDetails": {
                "name": pageName,		//Ex:en-ae:home
                "server": window.location.host,
                "siteSection": section,
                "siteSection1": "Home Navigation",
                "siteSection2": "",
                "siteSection3": "",
                "isErrorPage": true,
                "URL": window.location.href,
                "pageViews": {
                  "value": 1
                }
              }
            },
            "pageInfo": {
              "country": "ae",
              "language": localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
              "previousPageName": document.referrer,
              "pageType": "Home",
              "pageLoadTime": Math.floor(performance.now() / 1000)
            },
            "user": {
              "loginStatus": sessionStorage.getItem("isLoggedIn") ? "logged-in" : "logged-out",
              "customerId": sessionStorage.getItem("userId"),
              "customerType": sessionStorage.getItem("permission")
            },
            "timestamp": Date.now(),
            "userAgentString": navigator.userAgent,
            "errorInfo": {
              "error": 1,
              "errorMessage": errorMessage, // Incorrect otp
              "errorCode": errorCode, // error code
              "errorType": apiError ? 'API error' : 'Validation error'  //validation error/API Error
            }

          }
        });
      }
    } catch (e) {
      this.UTS.error(e)
    }
  };

}
